import i18n from "@/i18n"

const apiErrorV2Mappings = {
  name: { 'CUSTOM_FIELD.NAME_ALREADY_EXISTS': () => i18n.t('customField.toast.nameAlreadyExist') },
}

export default apiErrorV2Mappings